<template>
    <v-row dense>
        <v-col lg="6" md="6" sm="6" cols="12">
            <v-card
                class="verification-card"
                flat
                tile
                :class="
                    $vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-1'
                "
            >
                <v-card-actions class="justify-space-between px-0 flex-wrap">
                    <v-card-title class="pl-1" :style="{ color: verificationColor('identity') }">
                        <v-icon class="pr-3" color="ash-lighten-4">
                            mdi mdi-account-outline </v-icon
                        >Identity {{verificationStatus('identity')}}
                    </v-card-title>

                    <span class="edit" @click="clientPortalUrl()" >Go Client Portal to Edit</span>
                </v-card-actions>

                <div class="text-center">
                    <v-icon class="mb-3" size="100px" :style="{ color: verificationColor('identity') }">mdi mdi-account-outline</v-icon>
                    <p class="mb-0">Identity Verification is {{verificationStatus('identity')}}</p>
                </div>
            </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="6" cols="12">
            <v-card
                class="verification-card"
                flat
                tile
                :class="
                    $vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-1'
                "
            >
                <v-card-actions class="justify-space-between px-0 flex-wrap">
                    <v-card-title class='pl-1' :style="{ color: verificationColor('resident') }">
                        <v-icon class="pr-3" color="ash-lighten-4"
                            >mdi mdi-home-lightning-bolt-outline</v-icon
                        >Resident {{verificationStatus('resident')}}
                    </v-card-title>

                    <span class="edit" @click="clientPortalUrl()" >Go Client Portal to Edit</span>
                </v-card-actions>

                <div class="text-center">
                    <v-icon class="mb-3 " size="100px" :style="{ color: verificationColor('resident') }">mdi mdi-home-lightning-bolt-outline</v-icon>
                    <p class="mb-0">Resident Verification is {{verificationStatus('resident')}}</p>
                </div>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import toast from "@/services/Notification";
import { PROFILE__ACTIONS } from "@/store/action-types";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapActions, mapState } from "vuex";

export default {
    name: "ProfileVerification",
    components: {
        vueDropzone: vue2Dropzone,
    },
    data() {
        return {
            pdfImage: window.location.origin + "/static/images/pdf.png",
            dragging: false,
            dropzoneOptions: {
                acceptedFiles: "image/*",
                url: "https://httpbin.org/post",
                thumbnailWidth: 100,
                maxFilesize: 1024,
                headers: { "My-Awesome-Header": "header value" },
                maxFiles: 1,
                addRemoveLinks: true,
            },
            imageToPreview: "",
        };
    },
    computed: {
        ...mapState("profile", ["profile", "documentInfo"]),
    },
    methods: {
        ...mapActions("profile", [
            PROFILE__ACTIONS.IDENTITYVERIFICATION,
            PROFILE__ACTIONS.RESIDENCEVERIFICATION,
        ]),

        identityVerificationFileUpload(file) {
            if (!file) {
                toast.error("Please select a file to upload!");
                this.$refs.identityVerification.removeFile(file);
                return;
            }

            if (file.size > 4 * 1024 * 1024) {
                toast.error("File size should be less than 4MB");
                this.$refs.identityVerification.removeFile(file);
                return;
            }

            const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];

            if (!allowedFileTypes.includes(file.type)) {
                toast.error(
                    "Invalid file format. Upload JPG, JPEG, or PNG only."
                );
                this.$refs.identityVerification.removeFile(file);
                return;
            }

            const formData = new FormData();
            formData.append("identityVerification", file);
            // formData.append("otherField", data.otherField);

            this[PROFILE__ACTIONS.IDENTITYVERIFICATION](formData);
        },

        residenceVerificationFileUpload(file) {
            if (!file) {
                toast.error("Please select a file to upload!");
                this.$refs.residenceVerification.removeFile(file);
                return;
            }

            if (file.size > 4 * 1024 * 1024) {
                toast.error("File size should be less than 4MB");
                this.$refs.residenceVerification.removeFile(file);
                return;
            }

            const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];

            if (!allowedFileTypes.includes(file.type)) {
                toast.error(
                    "Invalid file format. Upload JPG, JPEG, or PNG only."
                );
                this.$refs.residenceVerification.removeFile(file);
                return;
            }

            const formData = new FormData();
            formData.append("residenceVerification", file);
            // formData.append("otherField", data.otherField);

            this[PROFILE__ACTIONS.RESIDENCEVERIFICATION](formData);
        },

        verificationStatus(type) {
            if(!this.profile) return;

            let checker = type == 'identity' ? this.profile.identity : this.profile.resident
            let verification_status=""

            if (checker === 0) {
                verification_status = "Not Verified"
            } else if (checker === 1) {
                verification_status = "Verified"
            } else if (checker === 2) {
                verification_status = "Pending"
            } else {
                verification_status = "Cancel"
            }
             
            return verification_status;
        },

        verificationColor(type) {
            if(!this.profile) return;

            let checker = type == 'identity' ? this.profile.identity : this.profile.resident
            let verification_color=""

            if (checker === 0) {
                verification_color = "#FF567F"
            } else if (checker === 1) {
                verification_color = "#039de9"
            } else if (checker === 2) {
                verification_color = "#D19909"
            } else {
                verification_color = "#FF567F"
            }
             
            return verification_color;
        },

        clientPortalUrl() {
            if(!this.profile) return;

            window.open(this.profile.client_portal_url, "_blank");
            return;
        }
    }
};
</script>
